// extracted by mini-css-extract-plugin
export default {"componentWrapper":"ChangeStatus_componentWrapper__hj8Xa","actions":"ChangeStatus_actions__rleJ9"};